// ── Sound Effects (Web Audio API – no external files needed) ──

let audioCtx = null;

function ctx() {
  if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  return audioCtx;
}

/**
 * Explosion-style "hit" sound — low rumble + sharp attack
 */
export function playHit() {
  const ac = ctx();
  const now = ac.currentTime;

  // Noise burst
  const bufferSize = ac.sampleRate * 0.35;
  const noiseBuffer = ac.createBuffer(1, bufferSize, ac.sampleRate);
  const data = noiseBuffer.getChannelData(0);
  for (let i = 0; i < bufferSize; i++) data[i] = Math.random() * 2 - 1;

  const noise = ac.createBufferSource();
  noise.buffer = noiseBuffer;

  // Bandpass for rumble
  const bp = ac.createBiquadFilter();
  bp.type = 'lowpass';
  bp.frequency.setValueAtTime(600, now);
  bp.frequency.exponentialRampToValueAtTime(80, now + 0.3);

  // Distortion for grit
  const dist = ac.createWaveShaper();
  const curve = new Float32Array(256);
  for (let i = 0; i < 256; i++) {
    const x = (i * 2) / 256 - 1;
    curve[i] = (Math.PI + 200) * x / (Math.PI + 200 * Math.abs(x));
  }
  dist.curve = curve;

  // Envelope
  const gain = ac.createGain();
  gain.gain.setValueAtTime(0.45, now);
  gain.gain.exponentialRampToValueAtTime(0.001, now + 0.35);

  noise.connect(bp).connect(dist).connect(gain).connect(ac.destination);
  noise.start(now);
  noise.stop(now + 0.35);

  // Low thud
  const osc = ac.createOscillator();
  osc.type = 'sine';
  osc.frequency.setValueAtTime(120, now);
  osc.frequency.exponentialRampToValueAtTime(40, now + 0.25);
  const oscGain = ac.createGain();
  oscGain.gain.setValueAtTime(0.5, now);
  oscGain.gain.exponentialRampToValueAtTime(0.001, now + 0.25);
  osc.connect(oscGain).connect(ac.destination);
  osc.start(now);
  osc.stop(now + 0.25);
}

/**
 * Water-splash "miss" sound — filtered white noise, quick fade
 */
export function playMiss() {
  const ac = ctx();
  const now = ac.currentTime;

  const bufferSize = ac.sampleRate * 0.3;
  const noiseBuffer = ac.createBuffer(1, bufferSize, ac.sampleRate);
  const data = noiseBuffer.getChannelData(0);
  for (let i = 0; i < bufferSize; i++) data[i] = Math.random() * 2 - 1;

  const noise = ac.createBufferSource();
  noise.buffer = noiseBuffer;

  // Bandpass for splash
  const bp = ac.createBiquadFilter();
  bp.type = 'bandpass';
  bp.frequency.setValueAtTime(3000, now);
  bp.frequency.exponentialRampToValueAtTime(800, now + 0.25);
  bp.Q.value = 0.8;

  // Envelope — quick fade
  const gain = ac.createGain();
  gain.gain.setValueAtTime(0.3, now);
  gain.gain.exponentialRampToValueAtTime(0.001, now + 0.25);

  noise.connect(bp).connect(gain).connect(ac.destination);
  noise.start(now);
  noise.stop(now + 0.3);
}
